export default __webpack_public_path__ + "static/media/15.8f947083.webp";